import { IntegrationListItem } from '../common/components/integration-list-item/integration-list-item'
import { integrationsMetadata } from '../common/metadata'
import { Integration } from '../common/interfaces'
import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import {
  IconAdd,
  IconCaretDown,
  IconCaretUp
} from '@contrast-security-inc/design-system-foundations'

interface JenkinsIntegrationProps {
  readonly integrations: Integration[]
}

export const JenkinsIntegration = ({
  integrations
}: JenkinsIntegrationProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleIsOpen = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      <IntegrationListItem
        isConnected={integrations.length > 0}
        {...integrationsMetadata.jenkins}
      >
        <>
          {integrations.length > 0 && (
            <span>
              <a className="no-underline text-smaller" onClick={toggleIsOpen}>
                {!isOpen && (
                  <>
                    <FormattedMessage
                      id={'action_integrationsSettings_showJobOutcomePolicies'}
                    />
                    <IconCaretUp color="neutral50" size="md" />
                  </>
                )}
                {isOpen && (
                  <>
                    <FormattedMessage
                      id={'action_integrationsSettings_hideJobOutcomePolicies'}
                    />
                    <IconCaretDown color="neutral50" size="md" />
                  </>
                )}
              </a>
            </span>
          )}
          <span
            className={`text-smaller ${
              integrations.length > 0 && 'integration-show'
            }`}
          >
            <a href={integrationsMetadata.jenkins.getUrlRoute()}>
              <span>
                <IconAdd size="sm" />
                <FormattedMessage
                  id={'action_integrationsSettings_addJobOutcomePolicy'}
                />
              </span>
            </a>
          </span>
        </>
      </IntegrationListItem>
    </>
  )
}
